/**
 * Errors that are an ANSWER, not a failure.
 *
 * A mutation that refuses on purpose — "these courts already have bookings,
 * confirm first", "this torneo still holds money" — travels as a thrown error
 * because that is how a repository says no to its caller. But the global
 * `MutationCache.onError` treats every rejection as a defect: it `console.error`s
 * and `captureException`s it, so a guard doing exactly its job would page us in
 * Sentry every time a club hits it. `PermissionDeniedError` already had a
 * bespoke early-return there; this is the same idea as a property any layer can
 * carry, so the app shell never has to import a feature's error classes.
 *
 * Marker-based rather than `instanceof`: subclassing across bundle boundaries is
 * fragile, and the check has to hold for anything the mutation layer rethrows.
 */
export interface ExpectedError {
  /** True when this rejection is a designed outcome the UI already handles. */
  readonly expected: true
}

/** Is this rejection a designed refusal rather than a bug? */
export function isExpectedError(error: unknown): boolean {
  return (error as Partial<ExpectedError> | null)?.expected === true
}
